"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EligibilityLookupToJSON = exports.EligibilityLookupFromJSONTyped = exports.EligibilityLookupFromJSON = void 0;
const runtime_1 = require("../runtime");
function EligibilityLookupFromJSON(json) {
    return EligibilityLookupFromJSONTyped(json, false);
}
exports.EligibilityLookupFromJSON = EligibilityLookupFromJSON;
function EligibilityLookupFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ktn': !runtime_1.exists(json, 'ktn') ? undefined : json['ktn'],
        'firstName': json['firstName'],
        'middleName': !runtime_1.exists(json, 'middleName') ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'dob': (new Date(json['dob'])),
        'countryOfBirth': json['countryOfBirth'],
        'countryOfCitizenship': !runtime_1.exists(json, 'countryOfCitizenship') ? undefined : json['countryOfCitizenship'],
        'cityOfBirth': !runtime_1.exists(json, 'cityOfBirth') ? undefined : json['cityOfBirth'],
        'affiliate': !runtime_1.exists(json, 'affiliate') ? undefined : json['affiliate'],
    };
}
exports.EligibilityLookupFromJSONTyped = EligibilityLookupFromJSONTyped;
function EligibilityLookupToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ktn': value.ktn,
        'firstName': value.firstName,
        'middleName': value.middleName,
        'lastName': value.lastName,
        'dob': (value.dob.toISOString().substr(0, 10)),
        'countryOfBirth': value.countryOfBirth,
        'countryOfCitizenship': value.countryOfCitizenship,
        'cityOfBirth': value.cityOfBirth,
        'affiliate': value.affiliate,
    };
}
exports.EligibilityLookupToJSON = EligibilityLookupToJSON;
//# sourceMappingURL=EligibilityLookup.js.map